export const en = {
    common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        create: 'Create',
        search: 'Search',
        logout: 'Log out',
        loading: 'Loading…',
        edit: 'Edit',
        back: 'Back',
        close: 'Close',
        refresh: 'Refresh',
        upload: 'Upload',
        yes: 'Yes',
        no: 'No',
        none: 'None',
        all: 'All',
        of: 'of',
        actions: 'Actions',
        status: 'Status',
        city: 'City',
        country: 'Country',
        language: 'Language',
        title: 'Title',
        name: 'Name',
        email: 'Email',
        password: 'Password',
        photo: 'Photo',
        cover: 'Cover',
        media: 'Media',
        locales: 'Locales',
        details: 'Details',
        overview: 'Overview',
        constructor: 'Constructor',
        review: 'Review',
        archive: 'Archive',
        approve: 'Approve',
        reject: 'Reject',
        saved: 'Saved',
        deleted: 'Deleted',
        created: 'Created',
        updated: 'Updated',
        error: 'Error',
        confirmDelete: 'Are you sure you want to delete this?',
        remove: 'Remove',
        add: 'Add',
        clear: 'Clear',
        clearSearch: 'Clear search',
        filter: 'Filter',
        reset: 'Reset',
        open: 'Open',
        view: 'View',
        duplicate: 'Duplicate',
        import: 'Import',
        export: 'Export',
        generate: 'Generate',
        sync: 'Sync',
        next: 'Next',
        previous: 'Previous',
        empty: 'Empty',
        required: 'Required',
        optional: 'Optional',
        dragToReorder: 'Drag to reorder',
        noResults: 'No results found',
        tryAgain: 'Something went wrong. Please try again.',
        unsaved: 'Unsaved',
        cannotBeUndone: 'This cannot be undone.',
        confirmSwitchTab: 'You have unsaved changes on this tab. Switch anyway?',
        confirmCloseUnsaved: 'You have unsaved changes. Close anyway?',
        discardChanges: 'Discard unsaved changes?',
        address: 'Address',
        description: 'Description',
        knownFor: 'Known for',
        category: 'Category',
        fame: 'Fame',
        recognition: 'Recognition',
        domain: 'Domain',
        domains: 'Domains',
        source: 'Source',
        author: 'Author',
        venue: 'Venue',
        quantity: 'Quantity',
        comment: 'Comment',
        date: 'Date',
        commission: 'Commission',
        promocode: 'Promocode',
        companyName: 'Company name',
        contactName: 'Contact name',
        avatar: 'Avatar',
        gallery: 'Gallery',
        url: 'URL',
        key: 'Key',
        label: 'Label',
        value: 'Value',
        kind: 'Kind',
        type: 'Type',
        from: 'From',
        to: 'To',
        distance: 'Distance',
        duration: 'Duration',
        timezone: 'Timezone',
        select: 'Select',
        selectAll: 'Select all',
    },
    nav: {
        dashboard: 'Dashboard',
        cities: 'City catalog',
        quests: 'City quests',
        routes: 'Audio routes',
        people: 'Historical figures',
        attractions: 'Attractions',
        collections: 'Collections',
        establishments: 'Establishments',
        districts: 'Districts',
        foods: 'Food',
        authors: 'Content authors',
        venues: 'Venue partners',
        activities: 'GetYourGuide tours',
        orders: 'Booklet supply',
        purchases: 'Content sales',
        reviews: 'Player reviews',
        translations: 'Translations',
        qa: 'Content QA',
        wiki: 'Wiki',
        users: 'Admin accounts',
    },
    enums: {
        purchaseProvider: {
            stripe: 'Stripe',
            iap: 'App Store / Play',
            cloudpayments: 'CloudPayments (.ru)',
        },
        purchaseScope: {
            route: 'Route',
            quest: 'Quest',
            city: 'City pack',
            pass: 'Pass',
        },
        experienceReviewStatus: {
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected',
        },
        experienceReviewSubject: {
            quest: 'Quest',
            route: 'Route',
        },
        attractionReviewStatus: {
            approved: 'Approved',
            needReview: 'Need review',
            rejected: 'Rejected',
            rejected_mcp: 'Rejected (MCP)',
        },
        personReviewStatus: {
            approved: 'Approved',
            needReview: 'Need review',
            rejected: 'Rejected',
            rejected_mcp: 'Rejected (MCP)',
        },
        attractionCategory: {
            museum: 'Museum',
            temple_church: 'Temple / church',
            architecture_landmark: 'Architecture landmark',
            palace_fortress: 'Palace / fortress',
            archaeological_site: 'Archaeological site',
            park_garden: 'Park / garden',
            viewpoint: 'Viewpoint',
            square: 'Square',
            street_district: 'Street / district',
            bridge: 'Bridge',
            market: 'Market',
            cemetery_necropolis: 'Cemetery / necropolis',
            theater_cultural_venue: 'Theater / cultural venue',
            monument_memorial: 'Monument / memorial',
            canal_waterfront: 'Canal / waterfront',
            transport_landmark: 'Transport landmark',
            stadium: 'Stadium',
            zoo_aquarium: 'Zoo / aquarium',
            gallery: 'Gallery',
            entertainment: 'Entertainment',
            natural_site: 'Natural site',
            unusual_place: 'Unusual place',
        },
        attractionFame: {
            icon: 'City icon',
            well_known: 'Well known',
            offbeat: 'Offbeat',
            hidden_gem: 'Hidden gem',
        },
        localeStatus: {
            empty: 'Empty',
            generated: 'Generated',
            reviewed: 'Reviewed',
        },
        attractionReadiness: {
            none: 'Not triaged',
            triaged: 'Triaged',
            passport: 'Passport',
            scouted: 'Scouted',
            light: 'Light card',
            base: 'Fact bank',
            brief: 'Brief',
            guide: 'Texts',
            audio: 'Audio',
        },
        attractionTier: {
            route: 'Route',
            full: 'Full story',
            light: 'Light card',
            silent: 'Silent pick',
        },
        attractionScoutVerdict: {
            rich: 'rich',
            medium: 'medium',
            poor: 'poor',
        },
        attractionReadinessCheck: {
            triage: 'triage',
            passport: 'passport',
            scout: 'scout',
            lightCard: 'light card',
            factBank: 'fact bank',
            photos: 'photos',
            coordinates: 'coordinates',
            interest: 'interest scores',
            brief: 'brief',
            guideTalk: 'guide talk',
            emojiFacts: 'emoji cards',
            hours: 'hours',
            visitDetails: 'ticket and visit',
            audio: 'audio guide',
        },
        establishmentKind: {
            spot: 'One place',
            cluster: 'Yard / food hall',
        },
        establishmentOffer: {
            coffee: 'Coffee',
            breakfast: 'Breakfast',
            food: 'Food',
            bar: 'Bar',
            wine: 'Wine',
            music: 'Music',
            market: 'Market',
        },
        establishmentStatus: {
            draft: 'Draft',
            published: 'In guides',
            closed: 'Closed',
        },
        establishmentLocaleStatus: {
            empty: 'Draft copy',
            ready: 'Ready for a guide',
        },
        guideStatus: {
            draft: 'Draft',
            published: 'In the guide',
        },
        guideLocaleStatus: {
            empty: 'Draft copy',
            ready: 'Ready for a guide',
        },
        establishmentPrice: {
            1: '1 · everyday',
            2: '2 · mid',
            3: '3 · a bit more',
            4: '4 · a night out',
        },
        intakeCuisine: {
            thai: 'Thai',
            isan: 'Isan',
            chinese: 'Chinese',
            indian: 'Indian',
            israeli: 'Israeli',
            japanese: 'Japanese',
            italian: 'Italian',
            french: 'French',
            mexican: 'Mexican',
            bakery: 'Bakery',
            seafood: 'Seafood',
            vegetarian: 'No meat',
            'street-food': 'Street food',
        },
        intakeDrink: {
            cocktails: 'Cocktails',
            'craft-beer': 'Craft beer',
            'natural-wine': 'Natural wine',
            gin: 'Gin',
            agave: 'Agave',
            roaster: 'We roast our coffee',
        },
        intakeRoom: {
            terrace: 'Terrace',
            rooftop: 'Rooftop',
            upstairs: 'Upstairs',
            counter: 'Counter only',
            listening: 'Listening room',
        },
        intakePets: {
            no: 'No',
            yes: 'Yes',
            outside: 'Outside only',
        },
        intakeAge: {
            all: 'All ages',
        },
        intakeBooking: {
            'walk-in': 'Walk in',
            helps: 'Booking helps',
            required: 'Booking required',
        },
        intakeCash: {
            no: 'No',
            yes: 'Yes',
        },
        weekday: {
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat',
            sun: 'Sun',
        },
        attractionRouteRole: {
            anchor: 'Must-see',
            primary: 'Highlight',
            connector: 'Connecting stop',
            optional: 'Supporting',
            detour: 'Side trip',
        },
        attractionTheme: {
            history: 'History',
            architecture: 'Architecture',
            art: 'Art',
            religion: 'Religion',
            nature: 'Nature',
            food: 'Food',
            shopping: 'Shopping',
            unusual: 'Unusual',
            panorama: 'Panorama',
            city_life: 'City life',
            culture: 'Culture',
            entertainment: 'Entertainment',
            traditions: 'Traditions',
        },
        attractionScenario: {
            with_kids: 'With kids',
            free: 'Free',
            rainy: 'Rainy day',
            evening: 'Evening',
            short_visit: 'Short visit',
            long_visit: 'Long visit',
            photogenic: 'Photogenic',
            first_visit: 'First visit',
            hidden_gem: 'Hidden gem',
            local: 'Local life',
            sunset: 'Sunset',
        },
        attractionAudioPotential: {
            strong: 'Strong story',
            medium: 'Enough for a story',
            low: 'Weak story',
            none: 'Not for audio',
            unassessed: 'Not assessed',
        },
        collectionKind: {
            must_see: 'What to see',
            first_visit: 'First visit',
            one_day: 'One day',
            with_kids: 'With kids',
            for_couples: 'For two',
            unusual: 'Unusual places',
            photogenic: 'For photos',
            viewpoints: 'Viewpoints',
            free: 'Free',
            rainy_day: 'Rainy day',
            evening: 'Evening',
            sunset: 'Sunset',
            hidden_gems: 'Hidden gems',
            local: 'Local life',
            museums_and_art: 'Museums and art',
            temples: 'Temples',
            walks: 'A walk',
            architecture: 'Architecture',
            history: 'History',
            audio: 'Audio walks',
            short_visit: 'A short stop',
            long_visit: 'Take your time',
            shopping: 'Shopping',
            food: 'Food',
        },
        attractionIndoorOutdoor: {
            indoor: 'Indoor',
            outdoor: 'Outdoor',
            mixed: 'Mixed',
        },
        funFactKind: {
            fact: 'Fact',
            legend: 'Legend',
        },
        personRecognition: {
            world: 'World',
            local: 'Local',
        },
        personDomain: {
            music: 'Music',
            literature: 'Literature',
            visual_art: 'Visual art',
            politics: 'Politics',
            architecture: 'Architecture',
            acting: 'Acting',
            science: 'Science',
            sport: 'Sport',
            film: 'Film',
        },
        personFactKind: {
            bio: 'Biography',
            anecdote: 'Anecdote',
            work: 'Work',
            quote: 'Quote',
            place: 'Place',
        },
        cityQuestStatus: {
            draft: 'Draft',
            need_review: 'Need review',
            rejected: 'Rejected',
            ready: 'Ready',
            paused: 'Paused',
        },
        cityQuestDisplayType: {
            scavenger_hunt: 'Scavenger hunt',
            walking_tour: 'Walking tour',
            ghost_tour: 'Ghost tour',
        },
        readyRouteStatus: {
            draft: 'Draft',
            need_review: 'In review',
            rejected: 'Needs changes',
            published: 'Published',
        },
        readyRouteGuideType: {
            first_visit: 'First time in the city',
            scenic: 'A beautiful walk',
            historical: 'Historical',
        },
        portalPartnerStatus: {
            new: 'New',
            invite_sent: 'Invite sent',
            landing_opened: 'Landing opened',
            registered: 'Registered',
            has_orders: 'Has orders',
            closed: 'Closed',
            blocked: 'Blocked',
            rejected: 'Rejected',
        },
        materialOrderStatus: {
            new: 'New',
            processing: 'Processing',
            shipped: 'Shipped',
            done: 'Done',
            canceled: 'Canceled',
        },
        portalPartnerType: {
            author: 'Author',
            venue: 'Venue',
        },
        artifactKind: {
            artwork: 'Artwork',
            manuscript: 'Manuscript',
            plaque: 'Plaque',
            relic: 'Relic',
            sculpture_detail: 'Sculpture detail',
            exhibit: 'Exhibit',
            other: 'Other',
        },
        challengeType: {
            count: 'Count',
            riddle: 'Riddle',
            observation: 'Observation',
            choice: 'Choice',
            anagram: 'Anagram',
            photo: 'Photo',
            time_dynamic: 'Time dynamic',
            sensor: 'Sensor',
            cipher: 'Cipher',
            ar_hunt: 'AR hunt',
        },
        sensorKind: {
            blow: 'Blow',
            shake: 'Shake',
            tilt: 'Tilt',
            compass: 'Compass',
        },
        cipherKind: {
            caesar: 'Caesar wheel',
            symbol_map: 'Symbol map',
        },
        dynamicAnswerRule: {
            server_compares_submitted_time_to_local_time: 'Submitted time vs local time',
            server_accepts_current_hour_figure_number_on_12h_cycle:
                'Current hour figure (12h cycle)',
        },
        routeEventType: {
            message: 'Message',
            theft_bonus: 'Theft bonus',
            timed_challenge: 'Timed challenge',
            gps_chase: 'GPS chase',
        },
        translationStatus: {
            not_ready: 'Not ready',
            waiting: 'Waiting',
            need_check: 'Need check',
            ready: 'Ready',
            skipped: 'Skipped',
        },
        countries: {
            it: 'Italy',
            ch: 'Switzerland',
            lv: 'Latvia',
            ee: 'Estonia',
            lt: 'Lithuania',
            cz: 'Czechia',
            pl: 'Poland',
            hu: 'Hungary',
            at: 'Austria',
            sk: 'Slovakia',
            hr: 'Croatia',
            pt: 'Portugal',
            es: 'Spain',
            gr: 'Greece',
            ru: 'Russia',
            de: 'Germany',
            fr: 'France',
            gb: 'United Kingdom',
            nl: 'Netherlands',
            ie: 'Ireland',
            dk: 'Denmark',
            se: 'Sweden',
            be: 'Belgium',
            is: 'Iceland',
            tr: 'Turkey',
            th: 'Thailand',
            cn: 'China',
            my: 'Malaysia',
            vn: 'Vietnam',
            hk: 'Hong Kong',
            mo: 'Macau',
            by: 'Belarus',
            ge: 'Georgia',
            jp: 'Japan',
            am: 'Armenia',
        },
        contentLanguage: {
            ru: 'Russian',
            en: 'English',
            it: 'Italian',
            de: 'German',
            pl: 'Polish',
            es: 'Spanish',
            fr: 'French',
        },
        capability: {
            view: 'View',
            text: 'Text',
            edit: 'Edit',
            delete: 'Delete',
        },
        questSource: {
            all: 'All',
            partner: 'Partner',
            admin: 'Admin',
        },
    },
    pages: {
        login: {
            title: 'Sign in',
            subtitle: 'Routellers admin — manage cities, quests, and partners.',
            email: 'Email',
            emailPlaceholder: 'you@routellers.com',
            password: 'Password',
            submit: 'Sign in',
            invalidEmail: 'Enter a valid email',
            passwordRequired: 'Enter your password',
        },
        dashboard: {
            title: 'Dashboard',
            sales: {
                title: 'Sales',
                week: 'Last 7 days',
                month: 'This month',
                purchases: 'Paid',
                refunded: 'Refunded',
                openPurchases: 'All purchases',
            },
            inbox: {
                title: 'Needs attention',
                items: {
                    questsNeedReview: 'Quests in review',
                    routesNeedReview: 'Routes in review',
                    attractionsNeedReview: 'Attractions in review',
                    peopleNeedReview: 'People in review',
                    reviewsPending: 'Player reviews pending',
                    ordersOpen: 'Booklet supply',
                    venuesNew: 'New venues',
                },
            },
            catalog: {
                title: 'Catalog',
                cities: 'Cities',
                citiesReady: '{{ready}} ready for Routellers of {{total}}',
                quests: 'Quests',
                routes: 'Routes',
                attractions: 'Attractions',
                people: 'People',
            },
        },
        cities: {
            title: 'City catalog',
            create: 'Create',
            searchPlaceholder: 'Search cities',
            columns: {
                id: 'ID',
                city: 'City',
                country: 'Country',
                routellers: 'Routellers',
                roadmap: 'Roadmap',
            },
            ready: 'Ready',
            hidden: 'Hidden',
            earlyAccess: 'Early access',
            priority: 'Priority',
            empty: 'No cities found.',
            fallbackSuffix: '— showing roadmap cities as fallback.',
        },
        cityDetail: {
            back: 'Cities',
            unsaved: 'Unsaved',
            openOnSite: 'Open city on site',
            readyBadge: 'Routellers',
            earlyAccessBadge: 'Early access',
            tabs: {
                overview: 'Overview',
                routes: 'Routes',
                locales: 'Locales',
                hero: 'Hero',
                story: 'Story',
                practical: 'Practical',
                faq: 'FAQ',
                seo: 'SEO',
                guide: 'Guidebook',
            },
            map: {
                places: 'Places',
                cafes: 'Cafés',
                summary: 'Districts {{districts}} · Routes {{routes}}',
                untitledRoute: 'Route {{id}}',
                untitledDistrict: 'District',
                noLine: 'no line',
                noOutline: 'no outline',
                empty: 'No districts or routes on the map yet.',
                leafletFailed: 'Could not load the map.',
                inRoute: 'On a route',
                notInRoute: 'Not on a route',
                pin: {
                    nutshell: 'In short',
                    funFact: 'Fun fact',
                    lookFor: 'Look for',
                    story: 'Story',
                    people: 'People',
                    routes: 'Routes',
                    free: 'Free entry',
                    ticket: 'Ticket required',
                    booking: 'Booking required',
                    family: 'Good with children',
                    rain: 'Fine in the rain',
                    night: 'Fine in the evening',
                    duration: 'About {{minutes}} min',
                    closed: 'closed',
                    find: 'How to find it',
                    since: 'Since {{year}}',
                },
            },
            guide: {
                lede: 'Districts and food live here, one language at a time. The button fills empty fields: hours, price, booking and the short texts. It leaves anything already written.',
                refresh: 'Update data',
                running: 'Collecting hours, prices and booking. This usually takes a few minutes.',
                refreshConfirmTitle: 'Update this city?',
                refreshConfirmBody:
                    'We will gather districts, district texts, food, hours, price and whether a visit needs a booking. Only empty fields are filled. Audio is left alone.',
                refreshUnsaved: 'Unsaved text on this screen will be reloaded from the server.',
                force: 'Replace facts that are already filled',
                forceHint:
                    'Hours, prices, flags and guidebook paragraphs. Audio scripts stay as they are.',
                run: 'Update',
                districts: 'Districts',
                food: 'Food',
                readyCount: '{{ready}} of {{total}} are ready in this language',
                searchDistricts: 'Find a district',
                searchFoods: 'Find a dish',
                addPlaceholder: 'District name',
                addFoodPlaceholder: 'Dish name',
                add: 'Add',
                emptyDistricts:
                    'No districts yet. Update data to gather them from place labels and public sources, or add one yourself.',
                emptyFoods:
                    'No dishes yet. Update data to suggest them from the places in this city.',
                name: 'Name for visitors',
                portrait: 'Character',
                portraitHint: 'What a walk here feels like. One paragraph.',
                why: 'Why go',
                whyHint: 'What this district has that the next one does not.',
                stay: 'Where to stay',
                stayHint: 'Who should base themselves here. No hotel list.',
                pitch: 'What it is',
                pitchHint: 'One paragraph: the dish, and why people eat it here.',
                textReady: 'This language is ready',
                textReadyHint: 'A ready text needs a name and at least one paragraph.',
                unsaved: 'Unsaved text',
                unsavedTitle: 'Save this text?',
                discard: 'Discard',
                service: 'Housekeeping',
                serviceHint:
                    'Visitors do not see this. The district appears on the site when a text is ready and publishing is on.',
                canonical: 'Canonical name',
                latitude: 'Latitude',
                longitude: 'Longitude',
                publish: 'Show on the site',
                remove: 'Delete district',
                removeConfirm:
                    'Delete this district? Places stay in the city. Only the link is removed.',
                removeFood: 'Delete dish',
                removeFoodConfirm: 'Remove this dish from the guidebook?',
                district: 'District',
                tables: 'Where to have it',
                order: 'What to order in this language',
                addTable: 'Add a place',
                pickTable: 'Place',
                noTables: 'No places yet. You can save the dish without them.',
                coordsHint: 'Latitude and longitude are set together.',
                publishNeedsText: 'Mark one language ready before publishing.',
                saved: 'Saved',
                saveHint:
                    'This saves the district or the dish. The button at the bottom of the page saves the city.',
                reportTitle: 'What was filled',
                reportDistricts: 'Districts: {{created}} created, {{filled}} with new text',
                reportPlaces: 'Places: {{updated}} updated, {{remaining}} still empty',
                reportTables: 'Tables: {{updated}} updated, {{remaining}} still empty',
                reportFoods: 'Dishes: {{created}} created',
                reportCity: 'Arrival texts: {{count}}',
            },
            identity: {
                title: 'Identity',
                description: 'Base city record. Localized display names live in Locales.',
                titleLabel: 'Title',
                country: 'Country',
                readyToLaunch: 'Ready to launch',
                earlyAccess: 'Early access',
                earlyAccessHint:
                    'Routes, quests and packs stay visible. The pay button becomes “Coming soon” until this is turned off.',
                coordinates: 'Coordinates (read-only): {{coords}}',
            },
            catalogPhoto: {
                title: 'Catalog photo',
                description: 'Card image on the home grid and city page fallback.',
            },
            hubImages: {
                title: 'Home screen images',
                description:
                    'A separate image for each item on the city home screen. If one is missing, the app keeps the default illustration.',
                route: 'Audio-guided walks',
                quest: 'Uncover the city’s secrets',
                free: 'Build your own route',
                people: 'In the footsteps of the great',
                activity: 'Things to do',
            },
            heroVideo: {
                title: 'Hero video',
                description: 'Language-independent. Prefer AV1 + H.264 for Safari fallback.',
                av1: 'AV1',
                h264: 'H.264',
                duration: 'Duration (seconds)',
            },
            heroStill: {
                title: 'Hero still',
                description: 'Poster frame and crop for the cinema hero.',
                poster: 'Poster',
                focus: 'Focus (object-position)',
                focusPlaceholder: 'center 58%',
            },
            displayNames: {
                title: 'Display names',
                description: '{{lang}} — player catalog, opening next, and city cards.',
                titleLabel: 'Title',
                inTitle: 'In-title',
                inTitleHint: 'Inflection used in “in Como” style copy.',
                nearTitle: 'Near-title',
                nearTitleHint: 'Inflection used in “near Como” style copy.',
            },
            heroHeadline: {
                title: 'Headline',
                description: '{{lang}} — kicker and italic punch above the H1.',
                region: 'Region kicker',
                regionHint: 'Above the H1, e.g. Lake Como · Lombardy, Italy',
                punch: 'Punch line',
                punchHint: 'Italic second line of the H1',
            },
            heroLede: {
                title: 'Lede',
                description: '{{lang}} — short line over the hero footage.',
                lede: 'Lede',
            },
            storyIntro: {
                title: 'Intro',
                description: '{{lang}} — opening paragraph under the hero.',
                opening: 'Opening paragraph',
            },
            storyChapters: {
                title: 'Chapters',
                description: '{{lang}} — ordered story blocks below the intro.',
                chapter: 'Chapter {{n}}',
                addChapter: 'Add chapter',
                chapterTitle: 'Title',
                chapterBody: 'Body',
            },
            practicalFacts: {
                title: 'Facts',
                description: '{{lang}} — practical rows (getting here, best months, …).',
                fact: 'Fact {{n}}',
                addFact: 'Add fact',
                label: 'Label',
                value: 'Value',
            },
            faq: {
                title: 'Questions',
                description: '{{lang}} — FAQ shown on the city page.',
                question: 'Question {{n}}',
                addQuestion: 'Add question',
                questionLabel: 'Question',
                answer: 'Answer',
            },
            seoSearch: {
                title: 'Search',
                description: '{{lang}} — meta description for search results.',
                metaDescription: 'Meta description',
            },
            partnerPitch: {
                title: 'Partner pitch',
                description: '{{lang}} — city-specific line on the for-hotels page.',
                hotelPitch: 'Hotel partner pitch',
            },
            arrival: {
                arrival: 'Getting in',
                arrivalHint: 'How a visitor arrives, and how they leave.',
                gettingAround: 'Getting around',
                gettingAroundHint: 'How to move once they are here.',
                commonMistake: 'Common mistake',
                commonMistakeHint: 'The thing visitors usually get wrong.',
                howLong: 'How many days',
                howLongHint: 'One sentence.',
                whenToGo: 'When to come',
                whenToGoHint: 'One paragraph: when to come, and when the city is a bad idea. No climate table.',
                money: 'Money',
                moneyHint: 'One line: card or cash, tipping. No prices.',
                festival: 'A date that changes the visit',
                festivalHint: 'One or two sentences, or leave empty.',
            },
            saveCity: 'Save city',
            deleteConfirm: 'Delete city #{{id}} ({{title}})?\n\nOnly empty cities can be deleted.',
            titleCountryRequired: 'Title and country are required.',
            saved: 'City saved.',
            deleted: 'City deleted.',
        },
        quests: {
            title: 'City quests',
            create: 'Create',
            searchPlaceholder: 'Search by key or title',
            statusAll: 'All statuses',
            sourceAll: 'All sources',
            partner: 'Partner',
            admin: 'Admin',
            columns: {
                quest: 'Quest',
                city: 'City',
                locales: 'Locales',
                stops: 'Stops',
                source: 'Source',
                status: 'Status',
            },
            empty: 'No quests match these filters.',
        },
        routes: {
            title: 'Audio routes',
            create: 'Create',
            searchPlaceholder: 'Search routes',
            statusAll: 'All statuses',
            openVoiceover: 'Open voiceover script',
            columns: {
                route: 'Route',
                city: 'City',
                locales: 'Locales',
                stops: 'Stops',
                author: 'Author',
                status: 'Status',
            },
            published: 'Published',
            draft: 'Draft',
            empty: 'No routes found.',
        },
        people: {
            title: 'Historical figures',
            create: 'Create',
            searchPlaceholder: 'Search by name',
            statusAll: 'All statuses',
            domainAll: 'All domains',
            fameAll: 'Any fame',
            withoutPhoto: 'Without photo',
            columns: {
                name: 'Name',
                city: 'City',
                locales: 'Locales',
                domains: 'Domains',
                fame: 'Fame',
                review: 'Review',
            },
            empty: 'No people found.',
        },
        attractions: {
            title: 'Attractions',
            create: 'Create',
            searchPlaceholder: 'Search by title',
            statusAll: 'All statuses',
            readinessAll: 'All levels',
            categoryAll: 'All types',
            themeAll: 'All interests',
            scenarioAll: 'All situations',
            audioAll: 'Any audio story',
            mustSeeAll: 'Any must-see',
            mustSeeHigh: 'Must-see 8+',
            storyRejects: 'Weak-story rejects',
            storyRejectsEmpty: 'No weak-story rejects in this city.',
            storyRejectsHint: 'These stays rejected until you restore a named card.',
            readinessNext: 'Next: {{items}}',
            readinessDone: 'Target reached',
            columns: {
                title: 'Title',
                readiness: 'Progress',
                locales: 'Locales',
                category: 'Category',
                mustSee: 'Must-see',
                review: 'Review',
            },
            empty: 'No attractions found.',
        },
        collections: {
            title: 'Collections',
            lede: 'Editorial lists. The same kinds exist in every city. A list is not a walking route.',
            pickCity: 'Choose a city to edit its lists.',
            emptyKind: 'Not created',
            places: '{{count}} places',
            name: 'Title',
            description: 'Description',
            seoTitle: 'SEO title',
            seoDescription: 'SEO description',
            cover: 'Cover URL',
            addPlace: 'Add place',
            searchPlace: 'Search places in this city',
            saved: 'Collection saved',
        },
        districts: {
            title: 'Districts',
            subtitle: 'Parts of the city a visitor can choose between. On the map this is a zone.',
            create: 'Create',
            backfill: 'Link labels',
            backfillConfirmCity: 'Create draft districts from the free-text labels in this city?',
            backfillConfirmAll: 'Create draft districts from free-text labels in every city?',
            backfillDone:
                'Created {{created}}. Linked {{attractions}} places and {{establishments}} establishments.',
            searchPlaceholder: 'Name or character',
            statusAll: 'All statuses',
            selectPlaceholder: 'District',
            selectNeedsCity: 'Choose a city first',
            selectEmpty: 'No districts in this city',
            empty: 'No districts yet.',
            columns: {
                name: 'District',
                city: 'City',
                guide: 'Guide text',
                status: 'Status',
            },
            editor: {
                newTitle: 'New district',
                fallbackTitle: 'District #{{id}}',
                created: 'District created',
                saved: 'Saved',
                deleted: 'Deleted',
                delete: 'Delete',
                confirmDelete: 'Delete “{{title}}”?',
                required: 'Name and city are required.',
                coords: 'Latitude and longitude come as a pair.',
                publishNeedsText: 'Publish needs one guide-ready language.',
                readyNeedsCopy:
                    'A ready language needs a name and a portrait, a reason, or where to stay.',
                identity: 'District',
                title: 'Canonical name',
                slug: 'Slug',
                slugHint: 'Leave empty to build it from the name.',
                city: 'City',
                district: 'District',
                lat: 'Latitude',
                lng: 'Longitude',
                status: 'Status',
                statusHint: 'Published districts can appear on the city page.',
                tabs: { card: 'Card', text: 'Text' },
                copyTitle: 'Guide text',
                copyHint:
                    'What this part of the city is like. Where to stay is a paragraph, not a hotel list.',
                name: 'Name',
                localName: 'Local name',
                localNameHint: 'The second line: Rattanakosin, Yaowarat, Petrogradka.',
                characterLine: 'Map line',
                characterLineHint: 'One phrase. Temples and the first day, bohemia.',
                portrait: 'Character',
                portraitHint: 'What it feels like to be here.',
                why: 'Why go',
                whyHint: 'Why a visitor comes, and at what time of day.',
                stay: 'Where to stay',
                stayHint: 'One paragraph about basing yourself here.',
                streets: 'Streets',
                streetsHint: 'The streets the area is known by. One line.',
                knownFor: 'Known for',
                knownForHint: 'One or two sentences. No prices or schedules.',
                tags: 'Tags',
                tagsHint: 'Short labels, comma separated. Crowded, Temples.',
                guideName: 'Guide name',
                guideRole: 'Role',
                guideTip: 'Guide note',
                guideTipHint: 'One practical note. A placeholder name is fine for now.',
                coverUrl: 'District photo',
                coverUrlHint: 'A frame that says which part of the city this is. File URL.',
                coverAuthor: 'Photo author',
                coverLicense: 'Licence',
                coverSourceUrl: 'File page',
                ready: 'Ready for the guide',
                readyHint: 'This language can be published.',
            },
        },
        foods: {
            title: 'Food',
            subtitle: 'A local ritual and the places that do it. One paragraph, no audio.',
            create: 'Create',
            searchPlaceholder: 'Name or ritual',
            statusAll: 'All statuses',
            empty: 'No food rituals yet.',
            columns: {
                name: 'Ritual',
                city: 'City',
                district: 'District',
                places: 'Places',
                status: 'Status',
            },
            editor: {
                newTitle: 'New food',
                fallbackTitle: 'Food #{{id}}',
                created: 'Food created',
                saved: 'Saved',
                deleted: 'Deleted',
                delete: 'Delete',
                confirmDelete: 'Delete “{{title}}”?',
                required: 'Name and city are required.',
                publishNeedsText: 'Publish needs one guide-ready language.',
                readyNeedsCopy: 'A ready language needs a name and a paragraph.',
                identity: 'Ritual',
                title: 'Canonical name',
                slug: 'Slug',
                slugHint: 'Leave empty to build it from the name.',
                city: 'City',
                districtHint: 'Optional. The part of the city this ritual belongs to.',
                status: 'Status',
                statusHint: 'Published rituals can appear on the city page.',
                tabs: { card: 'Card', text: 'Text' },
                copyTitle: 'Guide text',
                copyHint: 'What the ritual is and why people do it here.',
                name: 'Name',
                pitch: 'Paragraph',
                pitchHint: 'One paragraph. No menu, no prices.',
                ready: 'Ready for the guide',
                readyHint: 'This language can be published.',
                places: 'Where to eat it',
                placesHint: 'Published establishments. The note is what to order, per language.',
                orderNote: 'What to order ({{lang}})',
                addPlace: 'Establishment',
                add: 'Add',
            },
        },
        establishments: {
            title: 'Establishments',
            subtitle: 'Cafes, bars, yards and food halls for city guides.',
            create: 'Create',
            searchPlaceholder: 'Name, team, neighborhood',
            statusAll: 'All statuses',
            kindAll: 'All shapes',
            offerAll: 'All offers',
            ownerAll: 'All confirmations',
            reviewAll: 'All forms',
            empty: 'No establishments yet.',
            owner: {
                unconfirmed: 'Not confirmed',
                link_sent: 'Link sent',
                confirmed: 'Confirmed by the owner',
            },
            review: {
                pending: 'In review',
                rejected: 'Pack rejected',
                approved: 'Published',
                none: 'No pack',
            },
            columns: {
                name: 'Place',
                city: 'City',
                kind: 'Shape',
                offers: 'Offers',
                guide: 'Guide text',
                status: 'Status',
                owner: 'Owner',
                review: 'Form',
                visited: 'Opened',
                edited: 'Edited the form',
            },
            editor: {
                newTitle: 'New establishment',
                fallbackTitle: 'Establishment #{{id}}',
                created: 'Establishment created',
                saved: 'Saved',
                deleted: 'Deleted',
                delete: 'Delete',
                confirmDelete: 'Delete “{{title}}”?',
                required: 'Name and city are required.',
                hoursPair: '{{day}}: set both open and close, or leave the day unknown.',
                coords: 'Latitude and longitude are set together.',
                year: 'Opened year should be between 1800 and 2100.',
                publishNeedsText: 'Save guide-ready text in at least one language first.',
                readyNeedsCopy: 'A guide-ready text needs a display name and why people go.',
                tabs: {
                    card: 'Card',
                    intake: 'Form',
                    text: 'Text',
                    photos: 'Photos',
                    facts: 'Facts',
                },
                intakeLead:
                    'The same fields as the owner form. Guide text stays on Text, pictures on Photos.',
                door: 'The door',
                doorName: 'Name on the door',
                doorNameHint: 'Canonical name. The guide title is set on the Text tab.',
                reach: 'How to reach them',
                spend: 'What one person usually spends',
                spendUnset: 'Not sure',
                spendUnder: 'Under {{amount}} {{currency}}',
                spendOver: 'Over {{amount}} {{currency}}',
                cuisine: 'Cuisine, up to two',
                drink: 'Drink focus, up to two',
                room: 'The room, up to two',
                rules: 'House rules',
                pets: 'Dogs',
                age: 'Alcohol age',
                ageHint: 'The number is the legal age for alcohol in this country.',
                ageRestricted: '{{age}}+ the whole night',
                booking: 'Seats',
                cash: 'Cash only',
                unset: 'Not answered',
                closedTemporary: 'Temporarily closed',
                hoursNoteOnIntake: 'The Russian hours caveat is edited on the Form tab.',
                identity: 'Place',
                identityHint:
                    'One room, or a whole yard. A food hall is one card, not a card per stall.',
                title: 'Canonical name',
                slug: 'Slug',
                slugHint: 'Leave empty to build it from the name.',
                city: 'City',
                district: 'District',
                kind: 'Shape',
                kindHint:
                    'One place is a cafe or a bar. A yard is the whole food hall or courtyard.',
                offers: 'What people come for',
                offersHint: 'Several are fine: coffee by day, a bar at night.',
                operator: 'Who runs it',
                operatorHint: 'For search. Not printed in the guide.',
                where: 'Where',
                neighborhood: 'Neighborhood',
                address: 'Address',
                lat: 'Latitude',
                lng: 'Longitude',
                hours: 'Hours',
                hoursHint: 'An empty day is unknown, not closed. After midnight, write 02:00.',
                copyWeekdays: 'Weekdays same as Monday',
                closedDay: 'Closed',
                opens: 'Opens',
                closes: 'Closes',
                practical: 'Practical',
                contacts: 'Contact',
                contactsHint: 'The form goes out by WhatsApp, LINE, Instagram or Facebook.',
                instagram: 'Instagram',
                whatsapp: 'WhatsApp',
                facebook: 'Facebook',
                line: 'LINE',
                phone: 'Phone',
                website: 'Website',
                openedYear: 'Opened',
                priceLevel: 'Price',
                priceHint: 'Optional. Leave empty until someone has been.',
                status: 'Status',
                statusHint:
                    'In guides means a city guide may cite it. Closed keeps the row so it is not recommended again.',
                closedNote: 'Why it is closed',
                copyTitle: 'Guide copy',
                copyHint:
                    'This is the text a city guide prints. Facts stay short: why this crowd comes, and how to find the door.',
                displayName: 'Display name',
                tags: 'Tags',
                tagsHint:
                    'Chips on the card. Price is separate. Russian chips are rebuilt from the form.',
                specialties: 'Dish tags',
                specialtiesHint:
                    'One plate people come for. A second only if the room is honestly both. The card shows the guest’s language.',
                pitch: 'Why people go',
                pitchHint: 'One or two sentences.',
                findHint: 'How to find it',
                findHintHelp: 'Floor, courtyard, entrance.',
                hoursNote: 'Hours caveat',
                hoursNoteHint: 'Kitchen, a moved door, check before a visit.',
                ready: 'Ready for a guide',
                readyHint: 'Needs a display name and why people go.',
                intakeLink: 'Copy link',
                intakeCopied: 'Short link copied.',
                sendWhatsapp: 'WhatsApp',
                sendLine: 'LINE',
                sendInstagram: 'Instagram',
                ownerBox: 'Owner',
                packTitle: 'Pack',
                packSame: 'The facts match the card.',
                packChips: 'Publishing updates the chips.',
                photoCredit: 'Photo credit',
                coordsLabel: 'Coordinates',
                openMap: 'Open on the map',
                intakeChatOpened:
                    'The chat is open in a new tab. The link is already in the message.',
                intakeInstagramPaste: 'The message is copied. Paste it into the chat.',
                intakeNoChannel: 'Nowhere to send it: no WhatsApp, Facebook, Instagram or LINE.',
                intakeVisited: 'Opened',
                intakeEdited: 'Edited',
                intakeLinkSent: 'Link',
                intakeApprove: 'Publish pack',
                intakeReject: 'Reject',
                intakeApproved: 'Pack published. The guide text was left as it is.',
                intakeRejectedDone: 'Pack rejected. The public card is unchanged.',
                confirmApprove: 'Publish the owner pack? The guide text will not change.',
                confirmReject: 'Reject the pack? The public card stays as it is.',
                photos: 'Photos',
                photosHint: 'The star marks the cover a guide will use.',
            },
        },
        authors: {
            title: 'Content authors',
            create: 'Create',
            columns: {
                name: 'Name',
                commission: 'Commission',
                quests: 'Quests',
                inReview: 'In review',
                email: 'Email',
                status: 'Status',
            },
            verified: 'Verified',
            notVerified: 'Not verified',
            empty: 'No authors found.',
        },
        activities: {
            title: 'GetYourGuide tours',
            add: 'Add from GetYourGuide',
            addTitle: 'Attach a GetYourGuide tour',
            filterCity: 'Filter by city',
            pickCityFirst: 'Pick a city first',
            searchPlaceholder: 'Walking tour, boat cruise…',
            searchHint: 'Search GetYourGuide near the selected city, then attach tours.',
            attach: 'Attach',
            attached: 'Tour attached',
            alreadyAttached: 'Already attached',
            publish: 'Live',
            featured: 'Featured',
            notConfigured:
                'GetYourGuide Partner API is not configured. Set GETYOURGUIDE_ACCESS_TOKEN on the API.',
            empty: 'No activities yet. Pick a city and add tours from GetYourGuide.',
            status: {
                draft: 'Draft',
                published: 'Published',
            },
            columns: {
                tour: 'Tour',
                price: 'From',
                featured: 'Featured',
            },
        },
        venues: {
            title: 'Venue partners',
            create: 'Create',
            parseByCity: 'Parse venues by city',
            markInviteSent: 'Mark invite sent ({{count}})',
            blockSelected: 'Block selected',
            rejectSelected: 'Reject selected',
            columns: {
                venue: 'Venue',
                email: 'Email',
                city: 'City',
                promocode: 'Promocode',
                commission: 'Commission',
                status: 'Status',
            },
            empty: 'No venues found.',
            selectVenuesFirst: 'Select venues first',
            promptCityId: 'City ID to parse venues for:',
            invalidCityId: 'Invalid city id',
            confirmParse:
                'Parse tourist lodging (hotels, hostels, …) for city #{{id}} from Google Places?\n\nCreates new venues only. Existing closed places will be marked closed.',
            confirmBulkStatus: 'Set status "{{status}}" for {{count}} venues?',
            parsedTitle: 'Parsed {{city}}',
            parsedMessage:
                'Found {{found}} · created {{created}} · closed {{closed}} · skipped {{skipped}}',
            bulkUpdated: 'Updated {{count}} venues',
        },
        orders: {
            title: 'Booklet supply',
            columns: {
                date: 'Date',
                venue: 'Venue',
                qty: 'Qty',
                status: 'Status',
            },
            empty: 'No material orders.',
        },
        purchases: {
            title: 'Content sales',
            detailTitle: 'Purchase #{{id}}',
            detailFallback: 'Purchase',
            empty: 'No purchases match the filters.',
            permanent: 'Permanent',
            noEntitlement: 'No linked entitlement found.',
            noAttribution: 'No partner attribution on this purchase.',
            noConsent: 'No checkout consent log (typical for IAP).',
            tabs: {
                route: 'Routes',
                quest: 'Quests',
                city: 'Cities',
                pass: 'Passes',
            },
            status: {
                paid: 'Paid',
                refunded: 'Refunded',
            },
            entitlementStatus: {
                active: 'Active',
                expired: 'Expired',
                revoked: 'Revoked',
            },
            filters: {
                search: 'Buyer',
                searchPlaceholder: 'Email or name…',
                city: 'City',
                provider: 'Provider',
                status: 'Payment',
                allProviders: 'All providers',
                allStatuses: 'All',
            },
            columns: {
                date: 'Date',
                buyer: 'Buyer',
                product: 'Product',
                amount: 'Amount',
                provider: 'Provider',
                partner: 'Partner',
                status: 'Status',
            },
            sections: {
                product: 'Product',
                buyer: 'Buyer',
                payment: 'Payment',
                entitlement: 'Entitlement',
                attribution: 'Partner attribution',
                consent: 'Checkout consent',
            },
            fields: {
                scope: 'Scope',
                scopeId: 'Scope ID',
                city: 'City',
                email: 'Email',
                name: 'Name',
                playerId: 'Player ID',
                playerSince: 'Registered',
                lastLogin: 'Last login',
                emailVerified: 'Email verified',
                playerPurchases: 'Purchases by player',
                amount: 'Amount paid',
                tax: 'Tax',
                provider: 'Provider',
                externalId: 'External ID',
                refundedAt: 'Refunded',
                createdAt: 'Purchased',
                status: 'Status',
                entitlementId: 'Entitlement ID',
                source: 'Source',
                expiresAt: 'Expires',
                revokedAt: 'Revoked',
                storeTxn: 'Store transaction',
                venue: 'Venue',
                venueEmail: 'Venue email',
                promocode: 'Promocode',
                claimCode: 'Claim code',
                discount: 'Guest discount',
                claimAttributed: 'Attributed purchases on claim',
                commission: 'Commission',
                commissionStatus: 'Commission status',
                consentEmail: 'Consent email',
                docsVersion: 'Legal docs version',
                locale: 'Locale',
                consentAt: 'Consented at',
            },
        },
        reviews: {
            title: 'Player reviews',
            create: 'Add review',
            detailTitle: 'Review',
            empty: 'No reviews match the filters.',
            confirmDelete: 'Delete this review permanently?',
            createValidation: 'City, subject, author and body (20+ chars) are required.',
            localesHeading: 'Translations',
            noLocales: 'No translations yet — use “Translate to all languages”.',
            filters: {
                allStatuses: 'All statuses',
                allSubjects: 'All subjects',
            },
            columns: {
                author: 'Author',
                subject: 'Subject',
                rating: 'Rating',
                body: 'Review',
                locales: 'Languages',
                status: 'Status',
            },
            actions: {
                approve: 'Approve',
                reject: 'Reject',
                translateAll: 'Translate to all languages',
                delete: 'Delete',
            },
            fields: {
                subjectType: 'Type',
                subject: 'Quest / route',
                subjectPlaceholder: 'Select…',
                pickCityFirst: 'Pick a city first',
                authorName: 'Author name',
                authorAvatar: 'Author photo',
                sourceLanguage: 'Source language',
                rating: 'Rating',
                body: 'Review text',
                bodyHint: 'At least 20 characters. Written in the source language.',
                photos: 'Photos (up to 3)',
                publish: 'Publish now',
                publishYes: 'Approve immediately',
                publishNo: 'Leave in moderation queue',
            },
            toasts: {
                approved: 'Review approved.',
                rejected: 'Review rejected.',
                translated: 'Translated into {{count}} languages.',
                deleted: 'Review deleted.',
                created: 'Review created.',
            },
        },
        translations: {
            title: 'Translations',
            syncCdn: 'Sync CDN',
            generateJson: 'Generate JSON',
            namespace: 'Namespace',
            createKey: 'Create key',
            searchPlaceholder: 'Search key or text',
            allNamespaces: 'All namespaces',
            columns: {
                key: 'Key',
                namespace: 'Namespace',
                context: 'Context',
                locales: 'Locales',
            },
            empty: 'No translations found.',
            noContext: 'No context',
            saveLocale: 'Save locale',
            localeSaved: 'Locale saved.',
            localeTextRequired: 'Locale text is required.',
            jsonGenerated: 'JSON generated to CDN / disk.',
            syncedFromCdn: 'Synced from CDN.',
            syncedFromCdnStats: 'Synced from CDN ({{stats}}).',
            namespaceTitleRequired: 'Namespace title is required.',
            namespaceCreated: 'Namespace created.',
            keyRequiredFields: 'Key, source text and namespace are required.',
            translationKeyCreated: 'Translation key created.',
            createKeyModal: {
                title: 'Create translation key',
                namespace: 'Namespace',
                key: 'Key',
                sourceText: 'Source text',
                context: 'Context',
                create: 'Create',
            },
            createNamespaceModal: {
                title: 'Create namespace',
                titleField: 'Title',
                create: 'Create',
            },
        },
        users: {
            title: 'Admin accounts',
            createAdmin: 'Create admin',
            noAccess: 'You do not have access to this section.',
            tabs: {
                admins: 'Admins',
                activity: 'Activity',
                statistics: 'Statistics',
            },
            columns: {
                name: 'Name',
                email: 'Email',
                access: 'Access',
            },
            fullAccess: 'Full access',
            fieldAdmin: 'App admin',
            noRights: 'No rights',
            assignedRoutesCount: '{{count}} routes',
            empty: 'No admin accounts yet.',
            edit: 'Edit',
            delete: 'Delete',
            modal: {
                createTitle: 'Create admin',
                editTitle: 'Edit admin',
                account: 'Account',
                name: 'Name',
                email: 'Email',
                password: 'Password',
                newPassword: 'New password',
                passwordHint: 'Leave blank to keep the current password.',
                fullAccessSwitch: 'Full access (all sections)',
                fieldAdminSwitch: 'App admin',
                fieldAdminHint: 'The same email in the app can add technical waypoints and notes.',
                fieldAdminFromFullAccess:
                    'Full access already includes this. The separate switch is only for an admin without full access.',
                permissions: 'Permissions',
                permissionsHint: 'Grant access by section and capability.',
                assignedRoutes: 'Routes this admin can open',
                assignedRoutesHint:
                    'Only these routes open. Stop texts can be edited; structure, audio and metadata stay locked.',
                routeSearch: 'Find a route',
                noRoutesSelected: 'No routes selected — the list will be empty.',
                routesLoading: 'Loading routes…',
                cancel: 'Cancel',
                create: 'Create',
                save: 'Save',
            },
            nameEmailRequired: 'Name and email are required.',
            passwordRequired: 'Password is required.',
            adminCreated: 'Admin created.',
            adminUpdated: 'Admin updated.',
            cannotDeleteSelf: 'You cannot delete your own account.',
            confirmDelete: 'Delete admin {{email}}?',
            adminDeleted: 'Admin deleted.',
            sectionDescriptions: {
                dashboard: 'Overview and city pipeline summary.',
                cities: 'City catalog and locale meta.',
                quests: 'City quests — meta, constructor, locales.',
                routes: 'Ready walking routes. Text is stop copy on the routes you assign.',
                people: 'Historical people linked to cities.',
                attractions: 'Places / attractions pool.',
                establishments: 'Cafes, bars and yards a city guide can recommend.',
                authors: 'Portal author accounts.',
                venues: 'Portal venue accounts.',
                activities: 'GetYourGuide tours curated per city.',
                orders: 'Material orders from venue partners.',
                purchases: 'Content purchases — routes, quests, city packs and passes.',
                reviews: 'Player reviews for quests and ready routes.',
                translations: 'Translation keys and missing strings.',
                qa: 'Moderator text-edit quality quiz.',
                users: 'Create and manage admin accounts and rights.',
            },
            activity: {
                selectAdmin: 'Select admin',
                selectAdminHint: 'Pick an admin to see hourly activity for the day.',
                date: 'Date',
                empty: 'No activity for this day.',
                emptyRequests: 'No requests in this hour.',
                requests: 'Requests',
                requestsTitle: '{{email}} · {{date}} · {{hour}}',
                columns: {
                    hour: 'Hour',
                    requests: 'Requests',
                    firstRequest: 'First request',
                    lastRequest: 'Last request',
                    time: 'Time',
                    method: 'Method',
                    path: 'Path',
                },
            },
            statistics: {
                admin: 'Admin',
                allAdmins: 'All admins',
                startDate: 'Start date',
                endDate: 'End date',
                empty: 'No statistics for this range.',
                columns: {
                    date: 'Date',
                    workingHours: 'Working hours',
                    workingMinutes: 'Working minutes',
                    photosAdded: 'Photos added',
                    textsChanged: 'Texts changed',
                    statusesChanged: 'Statuses changed',
                    totalRequests: 'Total requests',
                },
            },
        },
        qa: {
            title: 'Content QA',
            remaining: '{{count}} waiting',
            empty: 'No text edits waiting for review.',
            emptyValue: '—',
            was: 'Was',
            became: 'Became',
            field: 'Field',
            aiEditor: 'AI',
            legendDeleted: 'removed',
            legendAdded: 'added',
            legendChanged: 'word changed',
            ok: 'Ok',
            bad: 'Bad',
            filters: {
                admin: 'Edited by',
                allAdmins: 'All admins',
                entityType: 'Entity type',
                allTypes: 'All types',
            },
            entityTypes: {
                attraction: 'Attraction',
                person: 'Person',
                route: 'Route',
                quest: 'Quest',
            },
        },
        wiki: {
            title: 'Moderator wiki',
            subtitle: 'Guides for reviewing and filling quests, attractions, and content ops.',
            back: 'All guides',
            groups: {
                moderation: 'Quest moderation',
                writing: 'Writing & editing',
                ops: 'Operations',
            },
            articles: {
                questModeration: {
                    title: 'Quest moderation guide',
                    summary: 'Fill, proofread, and verify quests from need_review to ready.',
                },
                questWriting: {
                    title: 'Quest writing guide',
                    summary: 'How to structure city quests, stops, and dramaturgy.',
                },
                attractionWriting: {
                    title: 'Attraction writing guide',
                    summary: 'Voice rules for attraction guide talks.',
                },
                routeWriting: {
                    title: 'Audio route writing guide',
                    summary:
                        'Overview vs thematic contracts, one-story stops, voice, facts, and route geometry.',
                },
                spbAttractionEditing: {
                    title: 'SPb attraction editing brief',
                    summary: 'Editorial pass to lift RU guide talks to a 10/10 standard.',
                },
                questTemplates: {
                    title: 'Scalable quest templates',
                    summary: 'City-agnostic plot templates for review and fill-in.',
                },
                contentOps: {
                    title: 'Content operations',
                    summary: 'Review statuses, pipelines, and people rules.',
                },
                arAnchorPhoto: {
                    title: 'AR anchor photo brief',
                    summary: 'How to shoot image-tracking anchors for ar_hunt stops.',
                },
            },
        },
    },
    editors: {
        establishmentFacts: {
            title: 'Venue fact bank',
            description:
                'The "why go" text is written only from facts marked Take or Must. A text needs four moves: hook, wit, warmth, tip.',
            beat: {
                hook: 'Hook',
                wit: 'Wit',
                warmth: 'Warmth',
                tip: 'Tip',
                find: 'How to find',
                background: 'Background',
            },
            beatPlaceholder: 'Move in the text',
            sources: '{{count}} sources',
            counter: 'showing {{shown}} of {{total}}, chosen {{chosen}}',
            copyPack: 'Copy fact pack',
            packIntro:
                'Editor-approved facts. Write the pitch per docs/venue-pitch-guide.md from these only. [!] means must use.',
            packCopied: 'Fact pack copied',
            remove: 'Delete',
            removeConfirm: 'Delete this fact?',
            emptyBank: 'No facts yet. An agent adds them over MCP, or an editor adds them by hand.',
        },
        attractionFacts: {
            title: 'Fact bank',
            description:
                'The researcher collects everything it finds; the AI editor checks and ranks it. You decide what goes into the story: "Take" and "Must" feed the brief.',
            startResearch: 'Run research',
            addFact: 'Add fact',
            noRuns: 'Research has not been run yet.',
            runLine:
                'Run #{{id}} ({{kind}}): {{status}}. Found {{found}}, new {{created}}, duplicates {{duplicates}}, quote confirmed for {{grounded}}, scored {{scored}}',
            usageLine:
                'Usage: input {{input}} (cached {{cached}}), output {{output}} (reasoning {{reasoning}}), web searches {{searches}}, calls {{calls}}',
            runKind: {
                research: 'research',
                deepen: 'deepen',
                dedupe: 'merge duplicates',
                score: 'draft scoring',
            },
            depth: {
                auto: 'Depth: auto',
                economy: 'Economy (up to $4)',
                standard: 'Ordinary stop',
                deep: 'Flagship: deep',
            },
            deepenChosen: 'Deepen picked',
            deepenOne: 'Deepen',
            deepened: 'deepened',
            dedupe: 'Merge duplicates',
            draftScore: 'Draft scoring',
            draftBadge: 'draft score',
            duplicateOf: 'duplicate of #{{id}}',
            runStarted: 'Run #{{id}} started',
            showLog: 'Show log',
            hideLog: 'Hide log',
            loading: 'Loading facts…',
            empty: 'No facts match this filter.',
            kindPlaceholder: 'Fact type',
            searchPlaceholder: 'Search text',
            rolePlaceholder: 'Role in the story',
            notePlaceholder: 'Editor note',
            aiPrefix: 'AI:',
            observable: 'visible on site',
            volatile: 'volatile',
            whereToSee: 'Where to see',
            sources: '{{count}} sources, {{grounded}} confirmed',
            usedIn: 'used in: {{list}}',
            groundedYes: 'quote found',
            groundedNo: 'quote not found',
            groundedUnknown: 'not checked',
            newClaim: 'Fact (one statement, in Russian)',
            newDetail: 'Context',
            newUrl: 'Source URL',
            newQuote: 'Source quote',
            view: {
                all: 'All',
                passed: 'AI passed',
                pending: 'Undecided',
                chosen: 'Taken',
                rejected: 'Rejected',
                duplicates: 'Duplicates',
            },
            decision: { pending: '—', take: 'Take', must: 'Must', reject: 'Reject' },
            role: {
                spine: 'Spine',
                bead: 'Story bead',
                hook: 'Hook',
                primer: 'Primer',
                card: 'Card',
                fun_fact: 'Fun fact',
                look_for: 'Look for',
                background: 'Background',
            },
            truth: {
                unchecked: 'unchecked',
                confirmed: 'confirmed',
                legend: 'legend',
                disputed: 'disputed',
                unverified: 'weak source',
                false: 'false',
            },
            verdict: {
                passed: 'passed',
                needs_check: 'needs check',
                failed: 'failed',
                duplicate: 'duplicate',
            },
            sensitivity: {
                none: '',
                tragedy: 'tragedy',
                memorial: 'memorial',
                religion: 'religion',
                politics: 'politics',
            },
            score: {
                surprise: 'surprise',
                retellability: 'retell',
                specificity: 'specific',
                visual: 'visual',
                humor: 'humor',
                placeRelevance: 'on place',
            },
            kind: {
                origin: 'Origin and purpose',
                anecdote: 'Anecdote',
                person: 'Person',
                event: 'Event',
                architecture: 'Architecture',
                visible_detail: 'Visible detail',
                legend: 'Legend',
                record: 'Record',
                pop_culture: 'Pop culture',
                everyday: 'Everyday life',
                scale: 'Scale',
                controversy: 'Controversy',
                tragedy: 'Tragedy',
                today: 'Today',
                other: 'Other',
            },
        },
        attractionBrief: {
            title: 'Story brief',
            description:
                'The story plan over selected facts. Prose is written only from an approved brief.',
            none: 'no brief',
            status: { draft: 'draft', approved: 'approved' },
            author: { ai: 'drafted by AI', editor: 'edited by editor' },
            promise: 'Stop promise',
            promiseHint: 'One line: why stop here.',
            spine: 'Spine',
            spineHint: 'The thread every story bead hangs on.',
            hookIdea: 'Opening hook',
            beads: 'Story beads',
            beadsHint:
                'Facts for guideTalk in telling order. Only "Take" and "Must" facts are listed.',
            cards: '"In short" cards',
            cardsHint: '2–3 cards of the same story, each with a punchline title idea.',
            cardTitle: 'Title idea',
            cardFacts: 'Card facts',
            addCard: 'Add card',
            extras: 'Fun fact and look-for',
            funFact: 'Fun fact',
            lookFor: 'Look for',
            notes: 'Notes for the writer',
            saveDraft: 'Save draft',
            approve: 'Approve brief',
            saved: 'Brief saved',
        },
        staffNotes: {
            title: 'Technical notes',
            description: 'Written in the app. Hidden from visitors.',
            empty: 'No notes yet.',
        },
        attraction: {
            newTitle: 'New attraction',
            fallbackTitle: 'Attraction #{{id}}',
            tabs: {
                details: 'Details',
                locales: 'Locales',
                media: 'Media',
                artifacts: 'Artifacts',
                facts: 'Facts',
                brief: 'Brief',
                review: 'Review',
            },
            identity: {
                title: 'Identity',
                titleLabel: 'Title',
                address: 'Address',
                country: 'Country',
                category: 'Category',
                fame: 'Fame',
                lat: 'Lat',
                lng: 'Lng',
                knownForEn: 'Known for (EN)',
                knownForHint: 'Seeds the English locale; edit later on the Copy tab.',
                descriptionEn: 'Description (EN)',
                descriptionHint: 'Seeds the English locale; edit later on the Copy tab.',
            },
            copy: {
                title: 'Copy',
                localeTitle: 'Locale title',
                knownFor: 'Known for',
                description: 'Description',
            },
            guidePackage: {
                title: 'Guide package',
                hook: 'Hook',
                guideTalk: 'Guide talk',
                cardN: 'Card {{n}}',
                cardEmoji: 'Emoji',
                cardTitle: 'Card title',
                cardBody: 'Card body',
                addCard: 'Add card',
                removeCard: 'Remove',
                funFact: 'Fun fact',
                funFactEmoji: 'Emoji',
                funFactTitle: 'Fun fact title',
                funFactKind: 'Kind',
                lookFor: 'Look for (comma-separated)',
                guideAudio: 'Guide audio',
                generateTts: 'Generate TTS',
                localeStatus: 'Locale status',
            },
            visit: {
                title: 'Visit',
                hint: 'Shown on the place card. Kept out of the audio.',
                durationMin: 'Visit from (min)',
                durationMax: 'Visit to (min)',
                isFree: 'Free to enter',
                ticketRequired: 'Ticket',
                bookingRequired: 'Booking',
                familyFriendly: 'Good with kids',
                rainFriendly: 'Works in the rain',
                nightFriendly: 'Works at night',
                hoursNote: 'Hours note',
                hoursNoteHint: 'A line about the hours. Not a price.',
                priceNote: 'Price',
                priceNoteHint: 'Current entry price, in one short line. Kept out of the audio.',
                visitNote: 'How to visit',
                visitNoteHint:
                    'Dress code, shoes, photos, prayer times, which entrance. Kept out of the audio.',
            },
            layers: {
                tier: 'Place target',
                tierHint: 'Route and full story go up to audio; a light card has no audio',
                lightApproved: 'Light card approved',
                triage: 'Triage: {{verdict}}, interest {{interest}}/10',
                scout: 'Scout: {{score}}/10, {{verdict}}. {{hooks}}',
            },
            attributes: {
                title: 'Attributes',
                tags: 'Interests',
                tagsHint: 'What the place is about. Kids, free, rain and evening are the visit flags below.',
                audioPotential: 'Audio story',
                audioHint: 'How strong a standalone story is. Tourist value stays in must-see. Empty uses the scout score.',
                audioFromScout: 'Scout suggests {{value}}. Saving a choice makes it editorial.',
                mustSeeScore: 'Must-see score (1–10)',
                wowScore: 'Wow score (1–10)',
                touristCrowdScore: 'Tourist crowd (1–10)',
                localExperienceScore: 'Local experience (1–10)',
                routeRole: 'Route role',
                indoorOutdoor: 'Indoor / outdoor',
                wikidataId: 'Wikidata id',
                isFreePreview: 'Free preview (unlocked without city pack)',
            },
            actions: {
                title: 'AI & maintenance',
                regenerate: 'Regenerate content',
                regenerateConfirm:
                    'Regenerate {{lang}} content with AI?\n\nThis overwrites the current locale text.',
                regenerated: 'Locale content regenerated.',
                ttsDone: 'Guide audio generated.',
                deepen: 'Deepen research',
                deepenDone: 'Research done, {{count}} fields filled.',
                generateCover: 'Generate cover',
                coverDone: 'Cover generated.',
                archive: 'Archive',
                unarchive: 'Unarchive',
                archiveConfirm:
                    'Archive attraction #{{id}}?\n\nIt will be hidden from players; you can unarchive it later.',
                archived: 'Attraction archived.',
                unarchived: 'Attraction unarchived.',
            },
            photos: {
                title: 'Photos',
                description: 'Star a photo to make it the cover (moved to first place).',
                gallery: 'Gallery',
            },
            artifactsPanel: {
                title: 'Artifacts inside this place',
                sectionDescription:
                    'Icons, manuscripts, plaques, exhibits — not separate map points. Players arrive here, then look for the object.',
                artifactN: 'Artifact {{n}}',
                remove: 'Remove',
                kind: 'Kind',
                personId: 'Person id (optional)',
                title2: 'Title',
                findHint: 'Find hint (room / floor / where to look)',
                knownFor: 'Known for',
                description: 'Description',
                wikidataId: 'Wikidata id',
                empty: 'No artifacts yet. Add objects players should find inside this place.',
                addArtifact: 'Add artifact',
            },
            moderation: {
                title: 'Moderation',
                rejectionReason: 'Rejection reason',
                reject: 'Reject',
                approve: 'Approve',
            },
            saveMarkReviewed: 'Save & mark reviewed',
            savePhotos: 'Save photos',
            saveArtifacts: 'Save artifacts',
            saveLocale: 'Save locale',
            titleCategoryFameRequired: 'Title, category, and fame are required.',
            cityRequired: 'City is required.',
            countryRequired: 'Country is required.',
            created: 'Attraction created.',
            saved: 'Attraction saved.',
            localeSaved: 'Locale saved.',
            photosSaved: 'Photos saved.',
            artifactTitleRequired: 'Each artifact needs a title.',
            artifactsSaved: 'Artifacts saved.',
            deleteConfirm: 'Delete attraction #{{id}}?\n\nThis cannot be undone.',
            deleted: 'Attraction deleted.',
            approved: 'Attraction approved.',
            rejected: 'Attraction rejected.',
        },
        person: {
            newTitle: 'New person',
            fallbackTitle: 'Person #{{id}}',
            tabs: {
                details: 'Details',
                media: 'Photos',
                locales: 'Locales',
                review: 'Review',
            },
            identity: {
                title: 'Identity',
                name: 'Name',
                primaryCity: 'Primary city',
                domains: 'Domains',
                fame: 'Fame',
                recognition: 'Recognition',
                recognitionHint: 'World = household name; Local = needs the city story',
            },
            photos: {
                title: 'Photos',
                description: 'Star a photo to mark it as the cover.',
                gallery: 'Gallery',
            },
            copy: {
                title: 'Copy',
                localeName: 'Locale name',
                knownFor: 'Known for',
                description: 'Description',
            },
            facts: {
                title: 'Facts',
                hint: 'Short bio / anecdote / quote cards for this language.',
                addFact: 'Add fact',
                kind: 'Kind',
                factTitle: 'Title',
                remove: 'Remove',
                localeStatus: 'Locale status',
            },
            moderation: {
                title: 'Moderation',
                reviewStatus: 'Review status',
                rejectionReason: 'Rejection reason',
                reject: 'Reject',
                approve: 'Approve',
            },
            saveMarkReviewed: 'Save & mark reviewed',
            savePhotos: 'Save photos',
            saveLocale: 'Save locale',
            nameRequired: 'Name is required.',
            domainRequired: 'Pick at least one domain.',
            fameRequired: 'Fame is required.',
            created: 'Person created.',
            saved: 'Person saved.',
            photosSaved: 'Photos saved.',
            localeSaved: 'Locale saved.',
            deleteConfirm: 'Delete person #{{id}}? This cannot be undone.',
            deleted: 'Person deleted.',
            approved: 'Person approved.',
            rejected: 'Person rejected.',
            discardLocaleConfirm: 'Discard unsaved locale changes?',
        },
        route: {
            newTitle: 'New ready route',
            fallbackTitle: 'Route #{{id}}',
            tabs: {
                meta: 'Meta',
                locales: 'Locales',
                constructor: 'Constructor',
            },
            cover: {
                title: 'Cover',
                description: 'Shown in the player catalog and route header.',
            },
            placement: {
                title: 'Placement',
                city: 'City',
                status: 'Status',
                guideType: 'Guide type',
                guideTypeHint: 'Badge on the route card in the app and on the site.',
                mobility: 'How you get there',
                mobilityHint: 'A walk stays in the city. Transit is a day trip.',
                mobilityWalk: 'On foot',
                mobilityTransit: 'Transit day trip',
            },
            author: {
                title: 'Author',
                description: 'Name and avatar are copied onto the route for player attribution.',
                attribution: 'Attribution: {{name}}',
            },
            walkingStats: {
                title: 'Walking stats',
                description: 'Filled automatically from the path when empty; you can override.',
                from: 'From (min)',
                to: 'To (min)',
                distance: 'Distance (km)',
            },
            catalogCopy: {
                title: 'Catalog copy',
                description: 'Route copy languages follow the selected city country.',
                titleField: '{{lang}} title',
                teaser: '{{lang}} teaser',
                description2: '{{lang}} description',
                transitNote: 'How to get there ({{lang}})',
                transitNoteHint: 'The ride out and back. Shown when this route is a day trip.',
            },
            constructorTab: {
                selectCityHint: 'Select a city on the Meta tab to load the map pool.',
                searchPlaceholder: 'Search on map…',
                found: '{{count}} found',
                none: 'None',
                placesStopsCount: '{{places}} places · {{stops}} stops',
                addWaypoint: 'Add waypoint',
                textOnlyHint: 'Click a stop to edit its text.',
                clickForWaypoint: 'Click map for waypoint…',
                stopsTitle: 'Stops',
                stopsDescription: 'Drag to reorder',
                noStops: 'No stops yet — add attractions from the map.',
                waypoint: 'Waypoint',
                stop: 'Stop',
                routeRole: 'Role in this route',
                routeRoleHint: 'Empty uses the place’s recommended role. A waypoint stays silent geometry.',
                alternateStart: 'Alternate start',
                alternateStartHint:
                    'The route can begin here and skip the earlier stops. The first stop is already the start.',
                alternateStartBadge: 'also a start',
                override: 'override',
                dragToMove: 'Drag to move',
                placeSectionTitle: 'Place · {{n}}',
                place: 'Place',
                waypointDescription: 'Waypoint — drag the marker on the map to move it.',
                selectedAttractionDescription: 'Selected attraction on the map.',
                addToRoute: 'Add to route',
                noWaypointTexts: 'Waypoint — no texts.',
                textsTitle: 'Texts',
                textsDescriptionOverride: 'Route overrides vs attraction source copy.',
                textsDescriptionSource: 'Attraction source copy.',
                noTextsInLang: 'No texts in {{lang}}.',
                hook: 'Hook',
                guideTalk: 'Guide talk',
                audioSection: 'Narration',
                guideAudio: 'Guide talk audio',
                audioHint: 'Length: {{guide}}.',
                routeTab: 'Route',
                attractionTab: 'Point',
                noAttractionTexts: 'No point texts in {{lang}}.',
                selectStopOrPoint: 'Select a stop or point on the map.',
            },
            saveRoute: 'Save route',
            cityRequired: 'City is required',
            titleRequiredIn: 'Title in {{lang}} is required',
            publishWithWarnings: 'Publish with warnings?\n\n{{warnings}}',
            publishWarningCount: '{{count}} publish warning(s)',
            noCoordinates: '{{title}}: no coordinates',
            routeCreated: 'Route created',
            routeSaved: 'Route saved',
            deleteConfirm: 'Delete route #{{id}}? This cannot be undone.',
            deleted: 'Route deleted.',
            noCoordinatesToast: 'This place has no coordinates',
            alreadyInRoute: 'Already in the route',
        },
        partner: {
            title: 'Partner',
            venue: 'Venue',
            author: 'Author',
            noEmailYet: 'No email yet (invite pending)',
            cityLabel: 'City: {{city}}',
            addressLabel: 'Address: {{address}}',
            phoneLabel: 'Phone: {{phone}}',
            websiteLabel: 'Website:',
            ratingLabel: 'Rating: {{rating}}',
            reviewsCount: ' ({{count}} reviews)',
            registered: 'Registered: {{date}}',
            emailVerified: 'Email verified: {{value}}',
            yes: 'yes',
            no: 'no',
            statsGames: 'Games: {{count}}',
            statsSales: 'Sales: {{amount}}',
            statsCommission: 'Commission: {{amount}}',
            statsQrScans: 'QR scans: {{count}}',
            statsClaims: 'Claims: {{count}}',
            statsGuests: 'Guests with email: {{count}}',
            statsPurchases: 'Purchases: {{count}}',
            contactName: 'Contact name',
            avatar: 'Avatar',
            avatarHint: 'Shown next to the author name on routes and quests.',
            companyName: 'Company name',
            status: 'Status',
            commissionPercent: 'Commission, %',
            discountPercent: 'Guest discount, %',
            discountPercentHint:
                'Discount for guests who scan this venue QR. Independent from the commission. Applies to new scans only.',
            promocode: 'Promocode',
            inviteQr: 'Invite QR',
            promoQr: 'Guest promo QR (for booklets)',
            promoQrHint:
                'Print this QR on marketing materials. Guests scan it to claim the discount; purchases are attributed to the venue.',
            noInviteToken: 'No invite token for this venue.',
            commissionRangeError: 'Commission must be a number between 0 and 100',
            discountRangeError: 'Guest discount must be a number between 0 and 100',
            statusRequired: 'Status is required',
            saved: 'Partner saved',
            deleteConfirm:
                'Delete partner #{{id}}?\n\nIf linked data exists, set status to blocked instead.',
            deleted: 'Partner deleted.',
        },
        partnerCreate: {
            newVenue: 'New venue',
            newAuthor: 'New author',
            newPartner: 'New partner',
            type: 'Type',
            contactName: 'Contact name',
            email: 'Email',
            passwordOptional: 'Password (optional)',
            passwordHint: 'Leave empty to auto-generate a temporary password.',
            companyName: 'Company name',
            commissionPercent: 'Commission %',
            tempPasswordNotice: 'Temporary password (copy now): {{password}}',
            close: 'Close',
            create: 'Create',
            nameEmailRequired: 'Name and email are required.',
            venueRequiresFields: 'Venue needs company name and city.',
            created: 'Partner created.',
            temporaryPasswordTitle: 'Partner created',
            temporaryPasswordMessage: 'Temporary password: {{password}}',
        },
        materialOrder: {
            title: 'Order #{{id}}',
            fallbackTitle: 'Material order',
            venue: 'Venue: {{name}}',
            quantity: 'Quantity: {{count}}',
            address: 'Address: {{address}}',
            comment: 'Comment: {{comment}}',
            status: 'Status',
            trackingInfo: 'Tracking info',
            save: 'Save',
            cancel: 'Cancel',
            updated: 'Order updated',
        },
        cityCreate: {
            title: 'New city',
            titleField: 'Title',
            titlePlaceholder: 'e.g. Munich',
            country: 'Country',
            create: 'Create city',
            titleCountryRequired: 'Title and country are required.',
            created: 'City created: {{title}} (#{{id}})',
        },
        questCreate: {
            title: 'New quest',
            titleField: 'Title',
            tagline: 'Tagline',
            originalLanguage: 'Original language',
            originalLanguageHint: 'Stops and texts are authored in this language first.',
            author: 'Author',
            authorHint: 'Portal author who owns this quest.',
            create: 'Create quest',
            titleCityRequired: 'Title and city are required.',
            created: 'Quest created.',
        },
        authorSelect: {
            label: 'Author',
            placeholder: 'Select author',
            noAuthor: 'No author',
            loading: 'Loading…',
            noAuthorsFound: 'No authors found',
        },
        citySearchSelect: {
            label: 'City',
            placeholder: 'Search cities…',
            searching: 'Searching…',
            noCitiesFound: 'No cities found',
        },
        quest: {
            fallbackTitle: 'Quest',
            fallbackTitleId: 'Quest #{{id}}',
            tabs: {
                meta: 'Meta',
                constructor: 'Constructor',
                locales: 'Locales',
            },
            delete: 'Delete',
            deleteConfirm: 'Delete quest {{key}}?\n\nThis cannot be undone.',
            deleted: 'Quest deleted.',
            overview: {
                cover: {
                    title: 'Cover',
                    description: 'Shown in the player catalog and admin list.',
                },
                catalog: {
                    title: 'Catalog',
                    description: 'Visibility and placement in the player catalog.',
                    status: 'Status',
                    primaryLanguage: 'Primary language',
                    primaryLanguageHint: 'Language the quest was authored in.',
                    author: 'Author',
                    authorHint: 'Portal author who owns this quest.',
                    displayType: 'Display type',
                    displayTypeHint:
                        'Marketing format shown in external catalogues (scavenger hunt, walking tour, ghost tour).',
                    navigatorQuestroomId: 'Escape Navigator questroom id',
                    navigatorQuestroomIdHint:
                        'Id of the listing in the Escape Navigator catalogue. Its page pulls route facts and price from us.',
                    rejectionReason: 'Rejection reason',
                },
                routeFacts: {
                    title: 'Route facts',
                    description: 'Language-independent numbers shown next to the title.',
                    distance: 'Distance, km',
                    duration: 'Duration, minutes',
                    durationMin: 'Duration min',
                    durationMax: 'Duration max',
                },
                markReady: 'Mark ready',
                markReadyConfirm:
                    'Mark this quest as ready? It will become visible in the player catalog.',
                statusRequired: 'Status is required.',
                saved: 'Quest saved.',
                markedReady: 'Quest marked ready.',
                validate: 'Validate',
                validation: {
                    title: 'Validation',
                    description: 'Publication readiness check; the status is not changed.',
                    noIssues: 'No issues found.',
                    playableLanguages: 'Playable languages:',
                    nonePlayable: 'none',
                },
            },
            locales: {
                catalogCopy: {
                    title: 'Catalog copy',
                    description:
                        'Player catalog title and tagline. Prologue and finale are edited in Constructor.',
                    titleField: 'Title',
                    tagline: 'Tagline',
                    voicedBy: 'Voiced by',
                    voicedByHint: 'Narrator credited for this language.',
                    localeStatus: 'Locale status',
                },
                prologue: {
                    title: 'Prologue',
                    description: 'Screens shown before the first stop.',
                    key: 'Key',
                    text: 'Text',
                    addScreen: 'Add screen',
                    audioUrl: 'Prologue audio URL',
                },
                finale: {
                    title: 'Finale',
                    description: 'Endings and the meta-puzzle.',
                    choicePrompt: 'Choice prompt',
                    id: 'Id',
                    label: 'Label',
                    ending: 'Ending',
                    addEnding: 'Add ending',
                    finalPuzzlePrompt: 'Final puzzle prompt',
                    finalPuzzleAnswers: 'Final puzzle answers (comma-separated)',
                    finalPuzzleHint: 'Final puzzle hint {{n}}',
                    addFinalPuzzleHint: 'Add final puzzle hint',
                    finalPuzzleExplanation: 'Final puzzle solution explanation',
                    audioUrl: 'Finale audio URL',
                },
                generateTts: 'Generate TTS',
                audioGenerated: 'Audio generated and saved to the locale.',
                titleRequired: 'Title is required for a locale.',
                saved: 'Locale saved.',
                saveLocale: 'Save locale',
                saveMarkReviewed: 'Save & mark reviewed',
            },
            constructor: {
                searchPlaceholder: 'Search on map…',
                placesStopsCount: '{{places}} places · {{stops}} stops',
                stopsTitle: 'Route',
                stopsDescription: 'Prologue → stops → finale. Drag only the numbered stops.',
                bookendPrologue: 'Prologue',
                bookendFinale: 'Finale',
                bookendFixed: 'Fixed',
                noStops: 'No stops yet — add attractions from the map.',
                milestone: 'milestone',
                noText: 'no text',
                newBadge: 'new',
                addToQuest: 'Add to quest',
                selectStopOrAttraction:
                    'Select prologue, a stop, finale, or an attraction on the map',
                stopFallback: 'Stop {{id}}',
                place: {
                    title: 'Place',
                    description: 'Attraction and GPS check-in.',
                    attraction: 'Attraction',
                    noAddress: 'No address',
                    gpsRadius: 'GPS radius (m)',
                    keyMilestone: 'Key milestone (shown on route preview)',
                },
                stopPhoto: {
                    title: 'Stop photo',
                    description: 'Optional. Empty — the attraction photo is used.',
                },
                challengeMechanics: {
                    title: 'Challenge mechanics',
                    description: 'Type and scoring. Prompt/answers are per language below.',
                    type: 'Type',
                    choiceIds: 'Choice ids (comma-separated)',
                    choiceIdsHint: 'Labels are translated per language below.',
                    doneAnswerNote:
                        "The service answer 'done' is added to accepted answers automatically on save.",
                    sensorKind: 'Sensor kind',
                    sensorDuration: 'Hold duration (sec)',
                    sensorTargetHeading: 'Target heading (°)',
                    sensorTolerance: 'Tolerance (°)',
                    dynamicRule: 'Dynamic answer rule',
                    dynamicRuleHint: 'The server checks the answer at submit time.',
                    dynamicTolerance: 'Tolerance',
                    dynamicToleranceHint: 'E.g. plus_minus_10_minutes.',
                    photoCollageSlot: 'Photo collage slot',
                    photoCollageSlotHint: 'Position of this photo in the finale collage.',
                    arHunt: {
                        collectRadius: 'Default collect radius (m)',
                        symbols: 'AR symbols',
                        symbolId: 'Id',
                        glyph: 'Glyph',
                        lat: 'Lat',
                        lng: 'Lng',
                        radius: 'Radius (m)',
                        spriteUrl: 'Sprite URL (overrides glyph)',
                        anchorImageUrl: 'Anchor image URL',
                        anchorImageUrlHint:
                            'Reference photo for image tracking; empty — compass AR.',
                        addSymbol: 'Add symbol',
                    },
                    expectedSolveTime: 'Expected solve time (sec)',
                    telemetryKey: 'Telemetry event key',
                },
                hintPenalties: {
                    title: 'Hint penalties',
                    description: 'Level and score penalty; the text is per language below.',
                    level: 'level {{n}}',
                    penalty: 'Penalty',
                    addLevel: 'Add hint level',
                },
                stopTexts: {
                    title: 'Stop texts',
                    description: 'Copy for {{lang}}. Catalog title lives on Locales.',
                    needsPromptHint:
                        'Challenge prompt and answers are required to make this stop playable in {{lang}}.',
                    chapterTitle: 'Chapter title',
                    nameBeforeSolving: 'Name before solving',
                    fromPrevious: 'From previous',
                    walkMicroTask: 'Walk micro-task',
                    arrivalInstruction: 'Arrival instruction',
                    storyBefore: 'Story before',
                    challengePrompt: 'Challenge prompt · {{type}}',
                    acceptedAnswers: 'Accepted answers (comma-separated)',
                    acceptedAnswersHint: 'Answers are language-specific.',
                    choiceLabels: 'Choice labels',
                    hintLevel: 'Hint level {{level}} (−{{penalty}})',
                    solutionExplanation: 'Solution explanation',
                    storyAfter: 'Story after',
                    historicalNote: 'Historical note',
                    metaToken: 'Meta-puzzle token',
                    metaTokenHint: 'Letter or symbol this stop grants in this language.',
                    sensorActionLabel: 'Sensor action label',
                    sensorSuccessText: 'Sensor success text',
                    arHuntSuccessText: 'AR hunt success text',
                    arHuntTargetHint: 'Target hint · {{id}}',
                    photoChallengePrompt: 'Photo challenge prompt',
                    photoExpected: 'Photo verification: expected content',
                    photoExpectedHint:
                        'What must be on the photo — criterion for the vision model. Empty — the photo is accepted on the honor system.',
                    photoMinConfidence: 'Photo verification: min confidence (0–1)',
                    cipher: {
                        kind: 'Cipher kind',
                        ciphertext: 'Ciphertext',
                        shift: 'Shift',
                        alphabet: 'Alphabet',
                        alphabetHint: 'Wheel alphabet; empty — Latin A–Z.',
                        symbolMap: 'Symbol map (symbol → letter)',
                        symbol: 'Symbol',
                        letter: 'Letter',
                        revealedPairs: 'Revealed pairs',
                        addPair: 'Add pair',
                    },
                    storyAudioUrl: 'Story audio URL',
                    walkAudioUrl: 'Walk audio URL',
                    challengeAudioUrl: 'Challenge audio URL',
                    generateTts: 'Generate TTS',
                    generateTtsSaveFirst: 'Save stops first to enable TTS generation.',
                    audioGenerated: 'Audio generated and saved to the locale.',
                },
                extras: {
                    title: 'Extras',
                    description:
                        'Optional media and side content. Texts are for {{lang}}, media is shared.',
                    thenPhoto: {
                        title: 'Then/now photo',
                        photo: 'Historical photo',
                        year: 'Year',
                        caption: 'Caption',
                    },
                    video: {
                        title: 'Video',
                        url: 'Video URL',
                        posterUrl: 'Poster URL',
                    },
                    evidence: {
                        title: 'Evidence',
                        image: 'Evidence image',
                        id: 'Id',
                        idHint: 'Stable key of the evidence within the quest.',
                        evidenceTitle: 'Title',
                        description: 'Description',
                    },
                    bonusSecret: {
                        title: 'Bonus secret',
                        points: 'Bonus points',
                        teaser: 'Teaser',
                        teaserHint: 'Subtle hint that a secret exists. Empty — fully hidden.',
                        prompt: 'Prompt',
                        acceptedAnswers: 'Accepted answers (comma-separated)',
                        hint: 'Hint',
                        solutionExplanation: 'Solution explanation',
                    },
                    teamSplit: {
                        title: 'Team split roles',
                        role: 'Role',
                        task: 'Task',
                        addRole: 'Add role',
                    },
                    fallback: {
                        title: 'Fallback',
                        prompt: 'Fallback prompt',
                        acceptedAnswers: 'Fallback accepted answers (comma-separated)',
                    },
                },
                routeEvents: {
                    title: 'Route events',
                    description:
                        'Beats between stops for {{lang}}: a message or bonus after the chosen stop is solved.',
                    untitledEvent: 'Untitled event',
                    key: 'Key',
                    type: 'Type',
                    afterStop: 'After stop',
                    afterStopShort: 'after {{n}}',
                    afterStopsCompleted: 'After N stops completed',
                    afterStopsCompletedHint: 'For free-order quests; alternative trigger.',
                    afterStopsCompletedShort: 'after {{n}} stops',
                    noTrigger: 'no trigger',
                    bonus: 'Bonus',
                    timer: 'Timer (sec)',
                    challenge: 'Challenge',
                    from: 'From',
                    text: 'Text',
                    challengePrompt: 'Challenge prompt · {{type}}',
                    acceptedAnswers: 'Accepted answers (comma-separated)',
                    solutionExplanation: 'Solution explanation',
                    chase: {
                        duration: 'Chase duration (sec)',
                        spawnDistance: 'Spawn distance (m)',
                        catchRadius: 'Catch radius (m)',
                        targetSpeed: 'Target speed (m/s)',
                        targetLabel: 'Target label',
                        successText: 'Success text',
                        failText: 'Fail text',
                    },
                    audioUrl: 'Audio URL',
                    addEvent: 'Add route event',
                },
                atLeastOneStop: 'A quest needs at least one stop.',
                eventNoTrigger:
                    'Route event "{{key}}" has no trigger (stop or completed-stops count).',
                removeStopConfirm:
                    'Remove stop "{{title}}"?\n\nIts texts in every language will be deleted on save.',
                removeStopEventsWarning: '\n{{count}} route event(s) will be unlinked.',
                stopsSaved: 'Stops saved.',
                saveStops: 'Save stops',
            },
        },
    },
    layout: {
        admin: 'Admin',
        logout: 'Log out',
        noAccess: 'No access',
        noPermission: 'You do not have permission for this section.',
        brand: 'Routellers',
    },
    pagination: {
        range: '{{from}}–{{to}} of {{total}}',
    },
    pipeline: {
        cityTools: 'City tools',
        promptCityId: 'City ID to process:',
        processCity: 'Process city',
        processingStatus: '{{city}}: {{stage}}',
        starting: 'starting',
        autolink: 'Autolink',
        stop: 'Stop',
        lastRun: 'Last: #{{id}} {{status}}',
        running: 'Running…',
        contentConfirm:
            'Also generate AI texts (RU only)?\n\nCancel — skeleton only: import → research → triage → enrich → autolink.\n\nOK — draft AI texts (RU) for places without content (longer, costs OpenAI). EN is skipped. Existing texts are never overwritten.',
        started: 'Pipeline #{{id}} started for {{city}}',
        stopConfirm: 'Stop pipeline #{{id}} ({{city}})?',
        cancelled: 'Pipeline cancelled',
        autolinkConfirm:
            'Autolink people ↔ attractions for city #{{cityId}}? Wikidata only — no OpenAI.',
        gapAudit: 'Find missing places',
        gapAuditRunning: 'Looking for missing places…',
        gapAuditConfirm:
            'Find places of city #{{cityId}} that are missing from the base? The model searches guidebooks and tours on the web, plus every Wikivoyage sight across districts; places with no story are dropped, the rest are added for review (needReview). 2–5 minutes.',
        gapAuditTitle: 'Missing places: {{city}}',
        gapAuditResult:
            'Candidates {{listed}}, already in base {{existing}}, added {{created}}, no coordinates {{unverified}}, dropped {{skipped}}',
        gapAuditCreated: 'Added',
        gapAuditUnverified: 'Check manually',
        autolinkResult:
            'Autolink: +{{created}} links · already {{already}} · scanned {{persons}} people / {{attractions}} places',
        processedTitle: '{{city}} processed',
        stoppedTitle: 'Pipeline stopped',
        unknownError: 'Unknown error',
        done: 'Done',
    },
    components: {
        mediaDropzone: {
            uploadFile: 'Upload file',
            replaceMedia: 'Replace media',
            removeMedia: 'Remove media',
            orPasteUrl: 'Or paste URL',
            unsupportedFile: 'Unsupported file. Use image, audio or video.',
        },
        coverUpload: {
            dropHere: 'Drop cover here',
            orClickToBrowse: 'or click to browse',
            uploading: 'Uploading…',
            replace: 'Replace',
            remove: 'Remove',
            viewFullSize: 'View full size',
            orPasteUrl: 'Or paste image URL',
            dropImageFile: 'Please drop an image file.',
        },
        imageLightbox: {
            defaultTitle: 'Photo',
            alt: 'Full size photo',
            close: 'Close',
            previous: 'Previous photo',
            next: 'Next photo',
        },
        photoUpload: {
            dropOrClick: 'Drop or click',
            squarePhotoHint: 'Square photo works best. JPG, PNG or WebP.',
            orPasteImageUrl: 'Or paste image URL',
            replace: 'Replace',
            remove: 'Remove',
            cover: 'Cover',
            setAsCover: 'Set as cover',
            dropPhotosHere: 'Drop photos here',
            uploading: 'Uploading…',
            orClickToBrowse: 'or click to browse',
            orPasteUrlEnter: 'Or paste image URL and press Enter',
            maxPhotos: 'Maximum {{max}} photos.',
            dropImageFile: 'Please drop an image file.',
            dropImageFiles: 'Please drop image files.',
            photos: 'Photos',
            addUrl: 'Add URL',
            urlUnreadable: 'Could not read an image from that URL.',
        },
        entityEditorShell: {
            unsavedChangesClose: 'You have unsaved changes. Close anyway?',
            unsaved: 'Unsaved',
        },
        requirePermission: {
            noAccess: 'No access',
            noAccessHint: 'You do not have permission for this section.',
        },
        attractionPhotos: {
            defaultTitle: 'Photo',
            alt: 'Attraction photo',
            close: 'Close',
            previousPhoto: 'Previous photo',
            nextPhoto: 'Next photo',
        },
        languageSwitcher: {
            ariaLabel: 'Language',
        },
        cityQuickSelect: {
            allCities: 'All cities',
            placeholder: 'City',
            nothingFound: 'No cities found',
        },
        countrySelect: {
            allCountries: 'All countries',
            placeholder: 'Country',
            nothingFound: 'No countries found',
        },
    },
} as const;
